module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("BATMAN RETURNS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Nananananananana BATMAN, Batman, Bat-maaaaaan. Grumpy, rich, no particular special powers, but a massive following nonetheless. Did you know there’s been more than one Robin? That sidekick’s name alone makes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Batman Returns")]), _vm._v(" a Chrimbo movie …")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Riddle Me This")])]), _c('p', {
    staticClass: "noindentL"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Name all the Christmas elements in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Batman Returns")]), _vm._v(". Convince your fellow players why this ought to be in the pantheon of Chrimbo films. The other player/s have the right to reply, of course: can they convince you that it shouldn’t be an Xmas movie?")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Which Batman?")]), _vm._v(" "), _c('p', {
    staticClass: "noindentL"
  }, [_vm._v("Put the following Batmen (Batmans?) in order of Batman-ness.")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("Movie Stars")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Christian Bale")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Robert Pattinson")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Michael Keaton")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Val Kilmer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ George Clooney")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Ben Affleck")])]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("TV and Oldies")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Adam West")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Lewis G. Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("⯌ Robert Lowery")])])]), _c('h3', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Rhetorical Question Time")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindentL"
  }, [_vm._v("As Bruce Wayne is so enormously rich, how come he doesn’t just fund a working police department in the first place? Where do his taxes go? And can one legally claim Batmobile maintenance against our taxes? These questions need to be answered!")]), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("20 Questions")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("1.")]), _vm._v(" The person that directed this movie has been involved with a few seasonally-set films – but what is his name?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("2.")]), _vm._v(" Which actor plays Batman in this iteration?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("3.")]), _vm._v(" And who plays Catwoman?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("4.")]), _vm._v(" Which vertically-challenged actor embodies the Penguin?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("5.")]), _vm._v(" What is the name of the gang that disrupts the tree-lighting ceremony?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("6.")]), _vm._v(" And what is the name of the businessman kidnapped by the Penguin?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("7.")]), _vm._v(" How does the Penguin become a hero?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("8.")]), _vm._v(" And what is the Penguin’s real name?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("9.")]), _vm._v(" How does Shreck attempt to murder his secretary, Selina?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("10.")]), _vm._v(" But she survives – how?")])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("11.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("And what does she do at home in anger?")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("12.")]), _vm._v(" How does she plan to get her own back on Shreck?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("13.")]), _vm._v(" Again she escapes a potentially fatal fall – how does she do it this time?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("14.")]), _vm._v(" How does Batman sabotage the Cobblepot Rally and therefore the Penguin’s mayoral race?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("15.")]), _vm._v(" As a result, what does Penguin vow to do by way of revenge?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("16.")]), _vm._v(" What is the technological ace that Penguin plays after Batman foils his Red Triangle Circus gang?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("17.")]), _vm._v(" How many times is Catwoman hit by shots from Shreck’s gun?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("18.")]), _vm._v(" Catwoman then takes out the building, Shreck and (presumably) herself. How?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("19.")]), _vm._v(" How does a desperate Penguin try and kill Batman, but fails?")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list"
  }, [_vm._v("20.")]), _vm._v(" Who do we see looking at the BatSignal at the very end?")])]), _c('p', {
    staticClass: "noindent1a"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Answers on ")])]), _c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter41#page_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 268")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673e6939","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter03.vue
// module id = 78
// module chunks = 0